export default "__VITE_ASSET__BaqJJqXe__"